import * as React from 'react';
import { FormGroup, Label } from '../../../components/Bootstrap';

interface DrinkEditorRowProps {
  label: string;
  for?: string;
}

export const DrinkEditorRow: React.FC<DrinkEditorRowProps> = (props) => {
  return (
    <FormGroup>
      <Label for={props.for}>{props.label}</Label>
      <div>{props.children}</div>
    </FormGroup>
  );
};
